export const header = () => {
    return { headers: {"Authorization" : `Bearer ${localStorage.getItem("sw_user_token")}`}}
}